import { Injectable } from '@angular/core';
import { EventTrigger } from '../models/vr-events/EventTrigger';

@Injectable({
  providedIn: 'root'
})
export class VrEventTriggerService {

  public triggers: EventTrigger[];
  constructor() { }

  getTrigger(eventTriggerId: any) {
    return this.triggers.filter(s => s.eventTriggerId == eventTriggerId)[0].trigger;
  }
}
